/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GoldenRecordConfigRoot } from '../models/golden-record-config-root';

@Injectable({
  providedIn: 'root',
})
export class GoldenRecordRulesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllGoldenRecordRules
   */
  static readonly GetAllGoldenRecordRulesPath = '/golden-record-rules/all';

  /**
   * Get all golden record configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllGoldenRecordRules()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllGoldenRecordRules$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<GoldenRecordConfigRoot>>> {

    const rb = new RequestBuilder(this.rootUrl, GoldenRecordRulesService.GetAllGoldenRecordRulesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GoldenRecordConfigRoot>>;
      })
    );
  }

  /**
   * Get all golden record configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllGoldenRecordRules$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllGoldenRecordRules(params?: {
  },
  context?: HttpContext

): Observable<Array<GoldenRecordConfigRoot>> {

    return this.getAllGoldenRecordRules$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<GoldenRecordConfigRoot>>) => r.body as Array<GoldenRecordConfigRoot>)
    );
  }

}
